<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { toast } from "vue-sonner";
import { hasAccess } from "@/utils/helper";

const linkAdd = {
  text: "Add Category Store Group",
  url: "/master/category-store-group/create",
};

const headers: Header[] = [
  { text: "CODE", value: "code" },
  { text: "CATEGORY GROUP NAME", value: "name" },
  { text: "CATEGORY STORE", value: "category_name" },
  { text: "DEPARTMENT", value: "department_name" },
  { text: "ACTIONS", value: "action" },
];

const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listCategoryStoreGroup = ref<any>([]);
const isLoading = ref(false);
const categoryGroupStore = useCategoryGroupStore();

const loadDataCategoryStoreGroup = async (query = "") => {
  isLoading.value = true;
  const { success, message } =
    await categoryGroupStore.dispatchGetCategoryGroups(
      page.value,
      limit.value,
      query
    );
  if (success) {
    listCategoryStoreGroup.value = await categoryGroupStore.categoryGroups
      .items;
    page.value = await categoryGroupStore.categoryGroups.page;
    limit.value = await categoryGroupStore.categoryGroups.pageSize;
    totalItems.value = await categoryGroupStore.categoryGroups.total;
    isLoading.value = false;
  }
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataCategoryStoreGroup();
};

const handleEdit = (categoryStoreGroup: any) => {
  router.push("/master/category-store-group/" + categoryStoreGroup);
};

const handleDelete = async (categoryStoreGroup: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${categoryStoreGroup.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await categoryGroupStore.dispatchDelete(
          categoryStoreGroup.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataCategoryStoreGroup();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataCategoryStoreGroup();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Category Store Group</h3>
      </div>
      <FilterTable
        :link="linkAdd"
        @searchByQuery="loadDataCategoryStoreGroup"
      />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listCategoryStoreGroup"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                v-if="hasAccess('group_category-update')"
                class="btn btn-info btn-sm text-white"
                @click="handleEdit(props.id)"
              >
                Edit
              </button>
              <button
                v-if="hasAccess('group_category-update')"
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
